module.exports = __webpack_public_path__ + "static/media/zflb_yxz.1aa5ad80.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/zflb_yxz.png
// module id = 2186
// module chunks = 0